/**
 * Authentication API - Using Generated Client
 * All functions are auto-generated from OpenAPI spec
 * Backward compatible with existing code
 */

import {
    postApiAuthSendOtp,
    postApiAuthVerifyOtp,
    postApiAuthCompleteProfile,
    postApiAuthMfaPasskeyOptions,
    postApiAuthMfaComplete,
    postApiAuthLogout,
    getApiAuthVerify,
    postApiAdminAuthLogin,
    postApiAdminAuthLogout,
    getApiAdminAuthVerify,
} from '@pki-pwa/api-client';
import { getAxios } from '@pki-pwa/api-client';
// Compatibility re-export still available via '@/generated/apiClient' shim if needed.
// Types are shared via @pki-pwa/shared-types (single source of truth, backend owns spec):
// import { SendOtpDto, VerifyOtpDto } from '@pki-pwa/shared-types';

class AuthAPI {
    /**
     * Send OTP to phone number
     */
    async sendOTP(phoneNumber) {
        return await postApiAuthSendOtp({ phoneNumber });
    }

    /**
     * Verify OTP code
     */
    async verifyOTP(phoneNumber, code) {
        return await postApiAuthVerifyOtp({ phoneNumber, otp: code });
    }

    /**
     * Complete user profile (after OTP verification)
     */
    async completeProfile(profileData) {
        return await postApiAuthCompleteProfile(profileData);
    }

    /**
     * Get passkey (WebAuthn) options for the second factor during login
     */
    async getLoginMfaPasskeyOptions(pendingToken) {
        return await postApiAuthMfaPasskeyOptions({ pendingToken });
    }

    /**
     * Get Dastine options for the second factor during login
     * Calls POST /api/auth/mfa/dastine-options
     */
    async getLoginMfaDastineOptions(pendingToken) {
        const response = await getAxios().post('/api/auth/mfa/dastine-options', { pendingToken });
        return response.data;
    }

    /**
     * Get Dastine challenge for passwordless primary login
     * Calls POST /api/auth/dastine/challenge
     */
    async getDastineChallenge() {
        const response = await getAxios().post('/api/auth/dastine/challenge');
        return response.data;
    }

    /**
     * Verify Dastine primary login
     * Calls POST /api/auth/dastine/verify
     */
    async verifyDastineLogin(payload) {
        const response = await getAxios().post('/api/auth/dastine/verify', payload);
        return response.data;
    }

    /**
     * Complete the login's second factor (TOTP / passkey / recovery)
     */
    async completeMfaLogin(pendingToken, factor, payload = {}) {
        return await postApiAuthMfaComplete({ pendingToken, factor, ...payload });
    }

    /**
     * Logout user
     */
    async logout() {
        return await postApiAuthLogout();
    }

    /**
     * Verify user token
     */
    async verifyToken() {
        return await getApiAuthVerify();
    }

    /**
     * Admin login
     */
    async adminLogin(username, password) {
        return await postApiAdminAuthLogin({ username, password });
    }

    /**
     * Admin logout
     */
    async adminLogout() {
        return await postApiAdminAuthLogout();
    }

    /**
     * Verify admin token
     */
    async verifyAdminToken() {
        return await getApiAdminAuthVerify();
    }

    /**
     * Operator login
     */
    async operatorLogin(username, password) {
        // Operators use the same admin login endpoint
        return await postApiAdminAuthLogin({ username, password });
    }

    /**
     * Operator logout
     */
    async operatorLogout() {
        return await postApiAdminAuthLogout();
    }

    /**
     * Verify operator token
     */
    async verifyOperatorToken() {
        return await getApiAdminAuthVerify();
    }
}

// Create singleton instance
const authAPI = new AuthAPI();

export default authAPI;
